import React from "react";
import Helmet from "react-helmet";
import Head from "../../components/Partials/Head";
import { getCurrentLanguage } from '../../assets/js/functions';

const LayoutHome = ({ pageMeta, children }) => {


  const lang = getCurrentLanguage();

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, { lang })
  );

  return (
    <>
      <Helmet>
        <html className="h-100" lang={getCurrentLanguage()} />
        {pageMeta.desc ? (
          <meta name="description" content={pageMeta.desc} />
        ) : (
          ""
        )}
        <Head></Head>
        <body id="top" className="is-size-6 home" />
      </Helmet>

      {childrenWithProps}

      {/* /main-content */}
    </>
  );
};

export default LayoutHome;
